import { cva } from 'class-variance-authority'

export const triggerStyles = cva(
  `
    flex
    h-10
    items-center
    justify-between
    whitespace-nowrap
    border
    border-neutral-200
    rounded-lg
    data-[state=open]:border-neutral-400
    bg-transparent
    px-4
    py-2
    text-sm
    shadow-sm
    text-neutral-600
    ring-offset-background
    data-[placeholder]:text-neutral-400
    focus:outline-none
    focus:border-neutral-200
    focus:border-1
    disabled:cursor-not-allowed
    disabled:bg-neutral-50
    disabled:text-neutral-400

    [&>span]:line-clamp-1
    cursor-pointer
    transform
    data-[state=open]:[&_.caret-down]:rotate-[-180deg]
  `,
  {
    variants: {
      variant: {
        default: `
          w-full
        `,
        text: `
          inline-flex
          mr-2
          text-md
          border-0
          focus:border-0
        `,
      },
      hasValue: {
        true: 'text-neutral-600',
        false: 'text-neutral-500',
      },
    },
  }
)

export const contentStyles = cva(
  `
    relative
    z-5000
    max-h-[--radix-select-content-available-height]
    min-w-[8rem]
    overflow-y-auto
    overflow-x-hidden
    rounded-md
    border
    bg-neutral-0
    text-neutral-600
    text-md
    shadow-md
    data-[state=open]:border-neutral-200
    data-[state=open]:animate-in
    data-[state=closed]:animate-out
    data-[state=closed]:fade-out-0
    data-[state=open]:fade-in-0
    data-[state=closed]:zoom-out-95
    data-[state=open]:zoom-in-95
    data-[side=bottom]:slide-in-from-top-2
    data-[side=left]:slide-in-from-right-2
    data-[side=right]:slide-in-from-left-2
    data-[side=top]:slide-in-from-bottom-2
    origin-[--radix-select-content-transform-origin]
  `,
  {
    variants: {
      variant: {
        default: '',
        text: '',
      },
      position: {
        popper: `
          data-[side=bottom]:translate-y-1
          data-[side=left]:-translate-x-1
          data-[side=right]:translate-x-1
          data-[side=top]:-translate-y-1
        `,
        'item-aligned': `
          data-[side=bottom]:translate-y-[var(--radix-select-trigger-height)]
          data-[side=left]:translate-x-[var(--radix-select-trigger-width)]
          data-[side=right]:-translate-x-[var(--radix-select-trigger-width)]
          data-[side=top]:translate-y-[var(--radix-select-trigger-height)]
        `,
      },
    },
  }
)

export const viewportStyles = cva(
  `
    p-1
    max-h-[200px]
    overflow-y-auto
  `,
  {
    variants: {
      variant: {
        default: '',
        text: '',
      },
      position: {
        popper: `
          h-[var(--radix-select-trigger-height)]
          w-full min-w-[var(--radix-select-trigger-width)]
        `,
        'item-aligned': `
          data-[side=bottom]:translate-y-1
          data-[side=left]:-translate-x-1
          data-[side=right]:translate-x-1
          data-[side=top]:-translate-y-1
        `,
      },
    },
  }
)

export const scrollButtonStyles = cva(
  `
    flex
    cursor-default
    items-center
    justify-center
    py-2
    text-neutral-400
  `
)

export const itemStyles = cva(
  `
    relative
    flex
    w-full
    cursor-pointer
    select-none
    items-center
    rounded-sm
    py-2
    pl-2
    text-md
    outline-none
    hover:bg-neutral-25
    focus:bg-accent
    focus:text-accent-foreground
    data-[disabled]:pointer-events-none
    data-[disabled]:bg-neutral-50
    data-[state=checked]:bg-moss-0
    data-[state=unchecked]:[&>.select-check]:hidden
  `,
  {
    variants: {
      variant: {
        default: '',
        text: '',
      },
    },
  }
)
export const selectValueStyles = cva(
  `
  `,
  {
    variants: {
      hasValue: {
        true: 'text-neutral-600',
        false: 'text-neutral-500',
      },
    },
  }
)

export const itemTextStyles = cva(
  `
    text-neutral-700
    text-md
    p-1
  `,
  {
    variants: {
      variant: {
        default: 'text-neutral-700',
        text: 'text-brand',
      },
    },
  }
)
